<template>

    <Head>
        <title>{{ $t('meta.serieslist_title') }}</title>
        <meta name="title" :content="$t('meta.serieslist_title')" />
        <meta name="description" :content="$t('meta.serieslist_description')" />
    </Head>
    <div class="main">
        <div v-if="!isPremium && false" class="ad-container">
            <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="5824393669"
                data-ad-format="auto" :data-full-width-responsive="true">
            </Adsense>
        </div>
        <div id="container">
            <a v-if="false" class="reklam" rel="sponsored"
                href="https://www.udemy.com/course/sfrdan-ileri-duzeye-mantgyla-ingilizce-ogren/?utm_campaign=DiziyleOgren&utm_medium=DiziyleOgren&utm_source=DiziyleOgren&couponCode=ANAKUPON"
                target="_blank">
            </a>
            <div class="primary-container">
                <h1 class="title">{{ $t("series_list.title") }}</h1>
                <p class="description mt-5">
                    {{ $t("series_list.description") }}
                </p>
                <input id="list-search" v-model="searchText" class="form-control mr-sm-2" type="search"
                    :placeholder="$t('series_list.search')" aria-label="Search">
                <div v-if="messageDiv">
                    <span>{{ $t("series_list.no_result") }}</span>
                </div>
            </div>
            <div v-if="!isPremium && false" class="ad-container-yatay">
                <Adsense data-ad-client="ca-pub-3579545649702539" data-ad-slot="5824393669" data-ad-format="auto"
                    :data-full-width-responsive="true">
                </Adsense>
            </div>
            <div class="card-container" v-if="seriesList.length != 0">
                <router-link class="card" :to="{ path: $store.getters.getLocaleLink('/dizi/') + series.combinedUrl }"
                    v-for="series in seriesList">
                    <img v-if="series.isPremium" class="premium" src="@/assets/Shared/premium.png">
                    <div :style="getUrlMap(series.urlLarge)" class="img1"></div>
                    <div :style="getUrlMap(series.urlLarge)" class="img2"></div>
                    <div class="text">{{ series.name }}</div>
                    <a href="#">
                        <div class="catagory">{{ $t("series_list.season",
                            series.seasons.length) }} <i class="fas fa-film"></i>
                        </div>
                    </a>
                    <a href="#">
                        <div :class="[(series.difficulty == 'Çok Kolay' ? 'very_easy_level' : ''), (series.difficulty == 'Kolay' ? 'easy_level' : ''), (series.difficulty == 'Orta' ? 'mid_level' : ''), (series.difficulty == 'Zor' ? 'difficult_level' : '')]"
                            class="views">{{ $store.getters.getLocaleDifficulty(series.difficulty) }} <i
                                class="fas fa-signal"></i> </div>
                    </a>
                </router-link>
            </div>
            <NewSeriesSurvey />
            <Loading v-if="seriesList.length == 0 && !messageDiv" />
        </div>

        <div v-if="!isPremium && false" class="ad-container">
            <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="5824393669"
                data-ad-format="auto" :data-full-width-responsive="true">
            </Adsense>
        </div>
    </div>
</template>

<script>

import NewSeriesSurvey from '../components/Account/NewSeriesSurvey.vue';

export default {
    data() {
        return {
            searchText: "",
            messageDiv: false
        };
    },
    components: {
        NewSeriesSurvey

    },
    methods: {
        getUrlMap(urlLarge) {
            var url = require("@/assets" + urlLarge)
            // var url = this.smallImageUrl
            return { 'background-image': `url("${url}")` }
        }

    },
    created() {

    },
    computed: {
        seriesList() {
            let tmp = this.$store.getters.getDOData.data.series
            if (this.searchText != "") {
                tmp = tmp.filter(x =>
                    x.name.toLowerCase().match(this.searchText.toLowerCase())
                );
            }
            if (tmp.length == 0 && this.searchText != "") {
                this.messageDiv = true
            } else {
                this.messageDiv = false
            }
            return tmp
        },
        isPremium() {
            return this.$store.getters.getUserData.isPremium
        },
        isAuthenticated() {
            return this.$store.getters.isAuthenticated
        },

    },
    watch: {

    }
};

</script>

<style scoped>
.main {
    display: flex;
    flex-direction: row;
    justify-content: center;
    -webkit-justify-content: center;
    gap: 24px;
    min-height: 100vh;
    width: 100%;
    padding-bottom: 48px;
}

#container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    max-width: 960px;
    -webkit-justify-content: center;
    -webkit-align-items: center;
}

.primary-container {
    border-radius: 16px;
    background-color: #FBFBFB;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 16px;
    width: 95%;
    max-width: 960px;
}

.title {
    color: var(--Primary, #8887C6);
    text-align: center;
    font-family: Poppins;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.description {
    color: #000;

    /* WEB/Body Medium */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.card-container {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 16px;
    margin-bottom: 16px;
}

.card {
    position: relative;
    overflow: hidden;
    width: 192px;
    height: 270px;
    background: #8887C6;
    border: 3px solid #8887C6;
    border-radius: 8px;
    box-shadow: 0 0 3px #8887C6;
    margin: 16px 8px;
}

.card .img1 {
    position: absolute;
    top: 0;
    left: 0;
    height: 60%;
    width: 100%;
    background-size: 189px 267px;
    background-position: left top;
    transition: all 0.5s ease-in-out;
}

.card .img2 {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 40%;
    width: 100%;
    background-size: 189px 267px;
    background-position: left bottom;
    transition: all 0.5s ease-in-out;
}

.premium {
    position: absolute;
    top: 0;
    left: 0;
    width: 20%;
    z-index: 2
}

.card .text {
    position: absolute;
    bottom: 40px;
    height: 120px;
    padding: 15px 10px;
    text-align: center;
    font-size: 18px;
    font-weight: 900;
    color: #FFF;
    transform: rotate(90deg);
    transform-origin: 0 100px;
    opacity: 0;
    transition: all 0.5s ease;
}

.card .catagory {
    position: absolute;
    left: 10px;
    top: 190px;
    padding: 3px 10px;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    background: #5a189a;
    color: #fff;
    border-radius: 5px;
    transform: translate(-160px, 0);
    transition: all 0.5s ease;
}

.card .views {
    position: absolute;
    left: 10px;
    top: 225px;
    padding: 3px 10px;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    border-radius: 5px;
    transform: translate(-160px, 0);
    transition: all 0.5s ease 0.15s;
    color: #fff;
}

.very_easy_level {
    background: #006400;
}

.easy_level {
    background: green;
}

.mid_level {
    background: blue;
}

.difficult_level {
    background: red;
}

.card:hover .img1 {
    transform: rotate(10deg) scale(1.3) translate(20px, 0);
    transform-origin: 300px 300px;
    opacity: 0.5;
}

.card:hover .img2 {
    transform: rotate(90deg) translate(0px, 150px);
    transform-origin: -20px 200px;
}

.card:hover .text {
    opacity: 1;
    transform: rotate(0deg);
}

.card:hover .views,
.card:hover .catagory {
    transform: translate(0);
}

.reklam {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    width: 920px;
    height: 250px;
    background-image: url("@/assets/Shared/udemy-reklam-web.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    padding: 0px;
    margin-bottom: 16px;
}

@media (max-width: 1300px) {
    .reklam {
        background-image: url("@/assets/Shared/udemy-reklam-mobile.png");
        width: 300px;
        height: 600px;
    }

    .main {
        flex-direction: column;
    }

    #container {
        min-width: 90%;
    }
}
</style>